
import { Component, Mixins } from "vue-property-decorator";
import SideMenuLayout from "@/views/sidebar/side-menu-layout.vue";
import ParticipantMixin from "@/views/sidebar/participant/participant.mixin";
import BaseMixin from "@/views/base/base.mixin";
import { ResearchParticipant } from "@/views/research/research.types";
import VueSelect from 'vue-select';

type SideMenuLayoutInstance = InstanceType<typeof SideMenuLayout>;
type VueSelectInstance = InstanceType<typeof VueSelect>;

@Component({
  components: {
    "side-menu-layout": SideMenuLayout
  }
})
export default class ParticpanyComponent extends Mixins(ParticipantMixin, BaseMixin ) {
  researchParticipant: ResearchParticipant = new ResearchParticipant();
  loading = false;
  participantNumber = "";
  isEdit = false;

  alertVisible = false;
  alertMessage = "";
  alertVariant = "success";

  async mounted() {
    this.loading = true;
    this.researchParticipant = JSON.parse(JSON.stringify(this.$sidebar.state?.item)); // maybe use lodash
    this.researchParticipant.researchDay1 = this.getDate(this.researchParticipant.researchDay1)!;
    this.researchParticipant.dob = this.getDate(this.researchParticipant.dob)!;
    this.researchParticipant.induction = this.getDateTime(this.researchParticipant.induction)!;
    this.isEdit = this.$sidebar.state?.subItem.isEdit;
    const client = await this.waitForClientReady();
    if (client) {
      await this.fetchData();
    } else {
      console.warn("Client not ready in time.");
    }
    this.loading = false;
  }

  async fetchData() {
    const fetch = [
      await this.$store.dispatch("Participant/fetchActiveMedications", this.selectedClientDDL.value),
      await this.$store.dispatch("Participant/fetchActiveImeis", this.selectedClientDDL.value),
      await this.$store.dispatch("Participant/fetchParticipantStatus", this.selectedClientDDL.value)
    ];
    await Promise.all(fetch);
  }

  async saveParticipant() {
    this.formSubmitted = false;
    this.$validator.validateAll().then(async (isValid: boolean) => {
      if (isValid) {
        this.loading = true;
        await this.$store.dispatch("Participant/upsertParticipantDetails", {
          clientId: this.selectedClientDDL.value,
          patientId: this.researchParticipant.patientId,
          phoneNumber: this.researchParticipant.phoneNumber,
          researchDay1: this.formatDate(this.researchParticipant.researchDay1),
          dob: this.formatDate(this.researchParticipant.dob),
          gender:this.researchParticipant.gender,
          dsm5: this.researchParticipant.dsm5 == 'Yes',
          medicationId: this.researchParticipant.medicationId,
          watchId: this.researchParticipant.watchId,
          changedByUserID: null,
          startDate: this.formatDate(new Date),
          induction: this.formatDateTime(this.researchParticipant.induction),
          status: this.researchParticipant.status
        });
        this.loading = false
        if (!this.errorMessage) {
          this.$sidebar.close( {success: true, reload: true} );
        } else {
          (this.$refs.sideMenu as SideMenuLayoutInstance).showAlert();
        }
     }
    });
  }

  handleBlur(refName: string): void {
    const selectComponent = this.$refs[refName] as VueSelectInstance
    const input = selectComponent?.$el?.querySelector('input')
    input?.blur()
  }
}
